import React, { useContext } from "react";
import { LangCtx } from "../../context";
// For CSS
import "./Dropdown.css";

const DropDown = (props) => {
    const { l } = useContext(LangCtx);
    return (
        <div className={`selectInput ${props.size}`}>
            <select label={props.label} onChange={props.onChange} value={props.value} name={props.name}>
                {props.items &&
                    props.items.length > 0 &&
                    props.items.map((item) => (
                        <option label={props.label} value={item?.value} key={`${item._id}${item.value}`}>
                            {item.label
                                ? item.label
                                : item.defaultlabel
                                ? l[item.defaultlabel]
                                : l[item.value]
                                ? props.checkUnderScore
                                    ? item.value.replaceAll("_", " ")
                                    : item.value
                                : item?.name}
                        </option>
                    ))}
            </select>
            <label>{props.labelText}</label>
            {props.error && <span className="selectErrorMsg">{props.errorMsg}</span>}
        </div>
    );
};
export default DropDown;
// props.checkUnderScore && props.checkUnderScore ? item.value.replaceAll("_", " ") : item.value
